import React from "react";
import { Modal } from "react-bootstrap";

import ImgcreditPayment from "./ImgcreditPayment";

export default class PaymentModal extends React.Component {
  render() {
    const { no_of_imgcredits, convenienceCharges } = this.props.fields;
    return (
      <Modal
        centered="true"
        show={no_of_imgcredits > 0}
        onHide={(e) => {
          this.props.resetImgcredit();
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul style={{ listStyleType: "none" }}>
            <li>
              <strong>
                Total Price for {no_of_imgcredits} Image Credits: $
                {no_of_imgcredits}
              </strong>
            </li>
            <li>
              <strong>
                Convenience Charges ({convenienceCharges * 100}%) : $
                {parseFloat(no_of_imgcredits * convenienceCharges).toFixed(2)}
              </strong>
            </li>
            <li>
              <strong>
                Grand Total: ${" "}
                {parseFloat(
                  no_of_imgcredits + no_of_imgcredits * convenienceCharges
                )}
              </strong>
            </li>
          </ul>
          <ImgcreditPayment no_of_imgcredits={no_of_imgcredits} />
        </Modal.Body>
      </Modal>
    );
  }
}
